import React from 'react';
import CustomSection from '../../custom-general/custom-section';

import classNames from './style.module.scss';
import { concatClassNames } from '../../../../utils/utilities';

const EmptyPID: React.FC = () => {
	return (
			<CustomSection sectionTitle="P&ID">
				<div className={classNames.anomalyLocationHeader}>
					P & ID Number: <span className="mx-2">N/A</span>
				</div>
				<div className={concatClassNames([classNames.anomalyLocation, classNames.anomalyLocationFullHeight])}>
					<p>No P & ID Available</p>
				</div>
			</CustomSection>
		);
};

export default EmptyPID;
